import { render } from "./formatted-date.vue?vue&type=template&id=e4385af4"
import script from "./formatted-date.vue?vue&type=script&lang=js"
export * from "./formatted-date.vue?vue&type=script&lang=js"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__